import { ArrowDown } from "lucide-react";
import { Button } from "../atoms/Button/index.js";
import { Tooltip } from "../molecules/Tooltip/index.js";

/**
 * Task 1 / Task 11 — the ONE control that returns a reader to the live end.
 *
 * Away from the bottom with nothing new it is a plain down arrow ("Jump to
 * latest"); once messages arrive the same control becomes the counted
 * "N new messages" pill. It floats over the thread, above the composer, and
 * takes no layout space, so showing, hiding or relabelling it never moves the
 * conversation.
 */
export function ChatJumpControl({
  newCount,
  onJump,
}: {
  newCount: number;
  onJump: () => void;
}) {
  return (
    <div
      data-chat-jump-control
      className="pointer-events-none absolute inset-x-0 bottom-3 z-raised flex justify-center"
    >
      {newCount > 0 ? (
        <Button
          variant="secondary"
          size="sm"
          shape="pill"
          className="pointer-events-auto"
          onClick={onJump}
        >
          {newCount === 1 ? "1 new message" : `${newCount} new messages`}
          <ArrowDown className="h-3.5 w-3.5" aria-hidden />
        </Button>
      ) : (
        <Tooltip content="Jump to latest" describeChild={false}>
          <Button
            variant="secondary"
            size="sm"
            shape="circle"
            iconOnly
            aria-label="Jump to latest"
            className="pointer-events-auto"
            onClick={onJump}
          >
            <ArrowDown className="h-4 w-4" aria-hidden />
          </Button>
        </Tooltip>
      )}
    </div>
  );
}
